import React, { useCallback, useEffect, useRef, useState } from 'react'
import '../../Styles/MapComp.css'

export const MapComp = ({ onClick,
  onIdle,
  onDragend,
  onBoundsChanged,
  onPlacesChanged,
  children,
  style,
  center,
  zoom,
  google,
  inputStreet,
  ...options }) => {

  const ref = useRef(null);
  const inputInMap = useRef(null);
  const searchBoxIsSeted = useRef(false);
  const [map, setMap] = useState();
  const [searchBox, setSearchBox] = useState();
  
  const [inSearchBox, setInSearchBox] = useState();

  const initSearchBox = useCallback(
    () => {
      const input = document.createElement('input');  
      input.setAttribute('type', 'text');
      input.className = 'controls';
      input.id = 'pac-input';
      input.placeholder = 'Buscar';
      inputInMap.current = input;
      setInSearchBox(new window.google.maps.places.SearchBox(input));
      
    },
    [],
  )

  useEffect(() => {
    if (ref.current && !map) {
      setMap(new window.google.maps.Map(ref.current, {}));
      initSearchBox();
      
    }
    if (inputStreet) {
      if (!searchBox) {
        setSearchBox(new window.google.maps.places.SearchBox(inputStreet.current));        
      }
    }
    if(map && !searchBoxIsSeted.current){
      map.controls[window.google.maps.ControlPosition.LEFT_TOP].push(inputInMap.current);
      searchBoxIsSeted.current = true;
    }

  }, [ref, map, searchBox, inputStreet, initSearchBox]);

  useEffect(() => {
    if (map) {
      map.setOptions({ center, zoom });
    }

  }, [map, center, zoom])

  useEffect(() => {
    if (map) {
      ["click", "idle", "dragend", "bounds_changed"].forEach((eventName) =>
        window.google.maps.event.clearListeners(map, eventName)
      );

      if (onClick) {
        map.addListener("click", onClick);
      }

      if (onIdle) {
        map.addListener("idle", () => onIdle(map));
      }
      if (onDragend) {
        map.addListener("dragend", () => onDragend(map));
      }      

      //Add Listener to searchBox for when a place has been selected
      if (searchBox) {
        ["places_changed"].forEach((eventName) =>
          window.google.maps.event.clearListeners(searchBox, eventName)
        );
        if (onBoundsChanged) {
          map.addListener("bounds_changed", () => onBoundsChanged(map, searchBox, inSearchBox))
        }
        if (onPlacesChanged) {
          searchBox.addListener("places_changed", () => onPlacesChanged(map, searchBox))
        }
      }
      if (inSearchBox) {
        ["places_changed", "bounds_changed"].forEach((eventName) =>
          window.google.maps.event.clearListeners(inSearchBox, eventName)
        );        
        if (onPlacesChanged) {
          inSearchBox.addListener("places_changed", () => onPlacesChanged(map, inSearchBox))
        }
      }
    }
  }, [map, searchBox, inSearchBox, onClick, onIdle, onDragend, onBoundsChanged, onPlacesChanged]);


  return (
      <div ref={ref} id="map" style={style}>
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            // set the map prop on the child component
            return React.cloneElement(child, { map });
          }
        })}
      </div>
  ) 
}
